export default __webpack_public_path__ + "static/media/sports3_hl.92b76942.png";